import React from 'react';
import GenericFilter from '../shared/tables/GenericFilter';
import Resources from '../shared/forms/Resources';
import { Validations } from '../shared/forms';
import { Options as EmployeeOptions } from '../employees/form/EmployeesDefinitions';
import AccessControl from '../shared/user/AccessControl';

const roleOptionsForCurrentUser = () => {
  const accessControl = new AccessControl();
  const options = {};
  const businessRoles = ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_RECRUITER'];
  for (let role of accessControl.getAllRolesCurrentUser()) {
    if (businessRoles.includes(role) && EmployeeOptions.roles[role]) {
      options[role] = EmployeeOptions.roles[role];
    }
  }

  return options;
};

const ComputedColumn = {
  roles: (row) => (row.roles || []).map((role) => EmployeeOptions.roles[role] || role).join(' / '),
  active: (row) =>
    row.active === false ? (
      <i className="fa fa-times text-danger" />
    ) : (
      <i className="fa fa-check text-success" />
    )
};

const UserDefinitions = {
  display_name: {
    title: 'Naam',
    column: { filter: GenericFilter, name: 'name' }
  },
  firstname: {
    title: 'Voornaam',
    initial: '',
    validation: Validations.name
  },
  surname_prefix: {
    title: 'Tussenvoegsel',
    initial: ''
  },
  surname: {
    title: 'Achternaam',
    initial: '',
    validation: Validations.name
  },
  email: {
    title: 'E-mail',
    initial: '',
    validation: Validations.email.required(),
    column: { filter: GenericFilter }
  },
  google_id: {
    title: 'Google ID',
    initial: '',
    placeholder: '000000000000000000000'
  },
  phone_number: {
    title: 'Telefoonnummer',
    validation: Validations.phone,
    initial: '',
    column: true
  },
  outgoing_email: {
    title: 'Uitgaand e-mailadres',
    initial: '',
    validation: Validations.email,
    column: true,
  },
  outgoing_phone_number: {
    title: 'Uitgaand telefoonnummer',
    initial: '',
    validation: Validations.phone,
    column: true,
  },
  locations: {
    title: 'Toegankelijke locaties',
    initial: [],
    column: true,
    value: (row) => (row.locations || []).map((location) => location.name).join(', '),
    resource: Resources.location,
    multiple: true
  },
  roles: {
    title: 'Rol',
    initial: ['ROLE_RECRUITER'],
    options: roleOptionsForCurrentUser,
    column: true,
    value: ComputedColumn.roles
  },
  active: {
    title: 'Actief',
    initial: true,
    options: {
      true: 'Actief',
      false: 'Inactief'
    },
    column: { filter: GenericFilter },
    value: ComputedColumn.active
  }
};

export default UserDefinitions;
export { roleOptionsForCurrentUser };
